// One pipeline restart at a time. The relay's onReady and onRestartNeeded and
// a device rotation can all ask for a restart together, and overlapping
// stop/start pairs each sent an init segment; every init makes the relay
// replace its ffmpeg (a new publish at the ingest).
//
// A request that arrives while a restart is still stopping is served by that
// restart. One that arrives after it began starting gets one more round,
// since that start may have read old dimensions or sent its init segment on
// a connection that has since been replaced.
export function createRestartQueue({ stop, start, canStart }) {
  let running = null;
  let requested = false;

  function run() {
    requested = true;
    if (!running) {
      running = (async () => {
        try {
          while (requested && canStart()) {
            await stop();
            if (!canStart()) break;
            requested = false;
            await start();
          }
        } finally {
          running = null;
          requested = false;
        }
      })();
    }
    return running;
  }

  return {
    run,
    // Lets a stop wait for an in-flight restart, which would otherwise start
    // the pipelines again after the stop.
    settled: () => (running ? running.catch(() => {}) : Promise.resolve()),
  };
}
